import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("button", {
    class: "gfu-btn gfu-btn--primary gfu-btn--compact gfu-btn--soft",
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.revertImpersonation && $options.revertImpersonation(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.UserBoxRevertImpersonationButton), 1 /* TEXT */)
    ])
  ]))
}